import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { CmsEntities } from 'client/data/models/cms';
import { SOURCES } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'client/site-modules/shared/components/image/image';
import { getCurrentMonth } from 'client/site-modules/shared/utils/time-util';

import './best-lease-deals-card.scss';

export function BestLeaseDealsCard({ entry, isMobile = false }) {
  const title = entry.metadata('title').value().replace('{months}', getCurrentMonth());
  const description = entry.metadata('description').value();
  const buttonText = entry.metadata('buttonText').value();

  return (
    <div className="best-lease-deals-card rounded-4 p-1_5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-1">
      <div className="d-flex align-items-center mb-1 mb-md-0">
        <div className="d-flex align-items-start gap-1 flex-grow-1">
          <Image
            lazy
            ariaHidden
            source={SOURCES.STATIC}
            imageId="/icons/lease-deals-gem.svg"
            className="object-fit-cover mt-0_25"
          />
          <div className="flex-grow-1">
            <h3 className="size-20 fw-bold text-dark mb-0_25">{title}</h3>
            <p className="size-14 mb-0">{description}</p>
          </div>
        </div>
      </div>
      <Button
        block
        tag={Link}
        color="blue-50"
        to="/lease-deals"
        data-tracking-value="View Deals"
        data-tracking-id="view_best_lease"
        data-tracking-parent="hidden-gems-display"
        className={classNames('view-lease-button text-transform-none py-0_5 px-2', {
          'w-100': isMobile,
          'w-auto': !isMobile,
        })}
      >
        {buttonText}
      </Button>
    </div>
  );
}

BestLeaseDealsCard.propTypes = {
  entry: CmsEntities.Content.isRequired,
  isMobile: PropTypes.bool,
};
